import angular from 'angular';

import {
  additionalFieldModel,
  companyModel,
  companySubsidiariesModel,
  configurationModel,
  contractModel,
  documentTypeModel,
  elementModel,
  executionModel,
  exportedMediaModel,
  featureModel,
  folderModel,
  groupModel,
  executionHistoryModel,
  listModel,
  repositoryModel,
  revisionHistoryModel,
  roleModel,
  signerInfoModel,
  signerModel,
  taskModel,
  userModel,
  workflowModel,
} from '../models';

const module = 'app.models';
const requires = [];

angular.module(module, requires);
angular.module(module).registerComponents(
  {
    additionalFieldModel,
    companyModel,
    companySubsidiariesModel,
    configurationModel,
    contractModel,
    documentTypeModel,
    elementModel,
    executionModel,
    exportedMediaModel,
    featureModel,
    folderModel,
    groupModel,
    executionHistoryModel,
    listModel,
    repositoryModel,
    revisionHistoryModel,
    roleModel,
    signerInfoModel,
    signerModel,
    taskModel,
    userModel,
    workflowModel,
  },
  'factory'
);
